
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal,ModalBody} from 'reactstrap';
import AnimationWrapper from './animationWrapper.js';

class ModalComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    triggerCallback = (receivedType) => {
        if (receivedType === "submit") {
                        this.props.callback({
                            type: receivedType,
                            uniqueModalReferenceId: this.props.uniqueModalReferenceId
                        })
        } else {
            this.props.callback({
                type: receivedType,
                uniqueModalReferenceId: this.props.uniqueModalReferenceId
            })
        }
    }

    render() {
        return (
            <div>
                {this.props.isVisible ? <div className="commonPopupFormBackDrop animated fadeIn"></div> : null}
                <AnimationWrapper.cssTransition isVisible={this.props.isVisible}>
                <Modal isOpen={true} size="sm" centered>
                        <ModalBody>
                        <div className="py-5 col-md-12 popupOuterMostContainer" style={{textAlign:'center'}} id={this.props.uniqueModalReferenceId}>
                        <div className="popupMainHeading pb-2">{this.props.mainHeading}</div>
                        <div className="popupContent pb-5"> {this.props.content}</div>
                
                        {this.props.isButtonGroupRequired ?
                                <div className="buttonGroup d-flex flex-row justify-content-center">
                                    {this.props.isCancelButtonVisible ?
                                        <button type="button" className="btn whiteButton mr-2" onClick={() => this.triggerCallback("cancel")}>{this.props.cancelButtonText}</button>
                                        : null}
                                   
                                    {this.props.isSubmitButtonVisible ?
                                        <button type="button" className="btn redButton ml-2" onClick={() => this.triggerCallback("submit")}>{this.props.submitButtonText}</button>
                                        : null}
                                </div>
                                : null}
                        </div>
                        </ModalBody>
                    </Modal>
                </AnimationWrapper.cssTransition>
            </div>
        );
    }
}

ModalComponent.defaultProps = {
    isVisible: false,
    isCancelButtonVisible: true,
    isSubmitButtonVisible: true,
    cancelButtonText: "Cancel",
    submitButtonText: "OK",
    content: ">>noChildrensToShow",
    mainHeading: ">>emptyMainHeading",
    uniqueModalReferenceId: "NA",
    isButtonGroupRequired: true,
    contentPartBackgroundColor:'#FFFFFF'
}

ModalComponent.propTypes = {
    isVisible: PropTypes.bool,
    isCancelButtonVisible: PropTypes.bool,
    isSubmitButtonVisible: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    submitButtonText: PropTypes.string,
    mainHeading: PropTypes.string,
    callback: PropTypes.func,
    uniqueModalReferenceId: PropTypes.string,
    isButtonGroupRequired: PropTypes.bool,
    contentPartBackgroundColor:PropTypes.string
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}

const ModalComponentContainer = connect(
    mapStateToProps
)(ModalComponent)

export default ModalComponentContainer;
